export default {
  Monday: [
    {
      title: "Tweet",
      time: "03:00 PM",
      category: { twitter: ["Twitter Feed"] },
      channels: ["twitter"],
    },
    {
      title: "UGC Content post",
      time: "06:00 PM",
      category: {
        twitter: ["Twitter Feed"],
        facebook: ["Facebook Feed"],
        instagram: ["Instagram Feed"],
      },
      channels: ["twitter", "facebook", "instagram"],
    },
  ],
  Tuesday: [
    {
      title: "Personal post",
      time: "02:00 PM",
      category: {
        twitter: ["Twitter Feed"],
        facebook: ["Facebook Feed"],
        instagram: ["Instagram Feed"],
      },
      channels: ["twitter", "facebook", "instagram"],
    },
  ],
  Wednesday: [
    {
      title: "Tweet",
      time: "03:00 PM",
      category: { twitter: ["Twitter Feed"] },
      channels: ["twitter"],
    },
    {
      title: "High Quality Image Post with Engagement CTA",
      time: "06:00 PM",
      category: {
        twitter: ["Twitter Feed"],
        facebook: ["Facebook Feed"],
        instagram: ["Instagram Feed"],
      },
      channels: ["twitter", "facebook", "instagram"],
    },
  ],
  Thursday: [
    {
      title: "IG Sticker /Q&A/Poll/Thread/GIF, Live",
      time: "11:00 AM",
      category: ["Twitter Feed", "Instagram Feed"],
      channels: ["twitter", "instagram"],
    },
    {
      title: "TikTok/Reels Content",
      time: "11:00 AM",
      category: ["Instagram Reels", "TikTok Feed"],
      channels: ["instagram", "tiktok"],
    },
    {
      title: "IG Carousel/ FB Gallery",
      time: "06:00 PM",
      category: {
        twitter: ["Twitter Feed"],
        facebook: ["Facebook Feed"],
        instagram: ["Instagram Feed"],
      },
      channels: ["twitter", "facebook", "instagram"],
    },
  ],
  Friday: [
    {
      title: "YT Community Update",
      time: "11:00 AM",
      category: { youtube: ["YouTube Community Tab"] },
      channels: ["youtube"],
    },
  ],
  Saturday: [
    {
      title: "Personal post",
      time: "02:00 PM",
      category: {
        twitter: ["Twitter Feed"],
        facebook: ["Facebook Feed"],
        instagram: ["Instagram Feed"],
      },
      channels: ["twitter", "facebook", "instagram"],
    },
  ],
  Sunday: [
    {
      title: "Personal post",
      time: "02:00 PM",
      category: {
        twitter: ["Twitter Feed"],
        facebook: ["Facebook Feed"],
        instagram: ["Instagram Feed"],
      },
      channels: ["twitter", "facebook", "instagram"],
    },
  ],
};
